import React, { useEffect } from 'react'
import { StatisticsMainPageProps } from './StatisticsMainPage.types'
import styles from './StatisticsMainPage.module.scss'
import cl from 'classnames'
import {
  Button,
  CurrencySelector,
  PageHeader,
  Text1
} from 'components/shared'
import { IconClose, IconCreateBill, IconStatistics } from 'assets'
import { Select } from 'components/shared/Select'
import { HighlightsSection } from 'components'
import { inject } from 'mobx-react'
import { STATISTICS_PAGE_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { User } from 'utilities'
import { OverviewStats } from '../OverviewStats'
import { ViewersStats } from '../ViewersStats'

const StatisticsMainPageComponent = (props: StatisticsMainPageProps) => {
  const {
    className,
    style,
    [STATISTICS_PAGE_STORE]: {
      onStatisticsMainPageMount,
      storesAsSelectOptions,
      // storeViewTabData,
      // setSelectedHighlightTab,
      selectedStoreId,
      setSelectedStoreId,
      selectedStores,
      excludeStore
      // shopToDisplay,
      // getHighlightTabs
    }
  } = props

  useEffect(() => {
    onStatisticsMainPageMount()
  }, [onStatisticsMainPageMount])

  const storeSelector = !User.isShopOwner() ? (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }} >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Text1
          style={{ color: styles.secondaryContent }}
        >
          Store
        </Text1>
        <Select
          noneLabel='All shops'
          value={selectedStoreId || ''}
          options={storesAsSelectOptions}
          onChange={setSelectedStoreId}
        />
      </div>
      <div className={styles.headerTagsAndCurrencySelectorContainer} >
        <div className={styles.headerTagsContainer}>
          {selectedStores.map(store => (
            <div
              key={store.id}
              className={styles.headerTag}
            >
              <Text1 overflowEllipsis>
                {store.name}
              </Text1>
              <Button
                preset='icon'
                onClick={() => excludeStore(store.id)}
              >
                <IconClose
                  fill={styles.primary}
                />
              </Button>
            </div>
          ))}
        </div>
        <CurrencySelector />
      </div>
    </div>
  ) : null

  return (
    <div
      className={cl(styles.pageContainer, styles.scrollable, className)}
      style={{ ...style, overflowX: 'hidden' }}
    >
      <PageHeader
        navSegments={[
          {
            label: 'Statistics',
            icon: IconStatistics
          }
        ]}
        middleContainerChildren={storeSelector}
        buttons={[{
          disabled: true,
          preset: 'link',
          style: {
            width: 'fit-content',
            display: User.isShopOwner() ? 'none' : undefined
          },
          children: (
            <>
              <IconCreateBill
                style={{
                  fill: styles.primary,
                  marginRight: 10,
                  marginTop: -3
                }}
              />
              Create a bill
            </>
          )
        }]}
      />

      {/* <SectionContainer>
        {shopToDisplay && (
          <>
            <EntityInfoNameLine
              entityName={shopToDisplay.name}
              imageProps={{
                src: getMainImageSrcForObj(shopToDisplay)
              }}
              ratingProps={{
                rating: shopToDisplay.rating,
                reviewsCnt: shopToDisplay.reviewsCnt
              }}
            />
            <HorizontalLine />
          </>
        )}

        <H2 style={{ marginTop: 20 }}>
          Highlights*
        </H2>
        <TabsLine
          style={{ marginTop: 10, position: 'relative' }}
          tabs={getHighlightTabs()}
          onSelectedTabChange={setSelectedHighlightTab}
        >
          <Numbers
            style={{
              position: 'absolute',
              right: 0,
              bottom: 15
            }}
          >
            {storeViewTabData.isTotalPrice
              ? formatPrice(storeViewTabData.total)
              : storeViewTabData.total}
            {storeViewTabData.afterTotalLabel && (
              <span className={styles.afterTotalLabel}>
                {storeViewTabData.afterTotalLabel}
              </span>
            )}
          </Numbers>
        </TabsLine>

        <div className={styles.circlesContainer}>
          {storeViewTabData.pieSegments.map((segment, index) => {
            return (
              <CirclePieSegment
                key={segment.label + segment.num}
                {...segment}
                circleBackgroundColor={statsColorPallette[index].background}
                circleFillColor={statsColorPallette[index].fill}
                delay={index}
              />
            )
          })}
        </div>

        <HorizontalLine />
        <Text2
          style={{
            marginTop: 15,
            color: styles.secondaryContent
          }}
        >
          *Statistics for {moment().subtract(1, 'day').format('DD/MM/YY')} (yesterday) compared to {moment().format('DD/MM/YY')}.
        </Text2>
      </SectionContainer> */}

      <HighlightsSection skipEffectOnInit />

      <OverviewStats
        style={{ marginTop: 20 }}
      />

      <ViewersStats
        style={{ marginTop: 20 }}
      />
    </div>
  )
}

const StatisticsMainPage = inject(
  STATISTICS_PAGE_STORE
)(observer(StatisticsMainPageComponent))
export { StatisticsMainPage }
